export default {
    id: "ID",
    dashboard: "ダッシュボード",
    warning: "警告",
    users: "ユーザー",
    farms: "農場",
    animals: "動物",
    action: "アクション",
    actionList: "アクションリスト",
    drugInventory: "医薬品の在庫",
    inseminatorStatistics: "授精者の統計",
    organizationNTR: "組織NTR",
    genotypePerformance: "遺伝子型パフォーマンス",
    semenAutomation: "精液自動化",
    activityLogs: "活動記録",
    username: "ユーザー名",
    title: "タイトル",
    deactivated: "無効化されました",
    name: "名前",
    email: "Eメール",
    emailAddress: "電子メールアドレス",
    mobileNum: "携帯電話番号",
    emailOrMobile: "メール/モバイル",
    role: "役割",
    roles: "役割",
    department: "デパートメント",
    status: "スターテス",
    pages: "ページ",
    departments: "部門",
    password: "パスワード",
    cancel: "キャンセル",
    submit: "送信",
    error: "エラー",
    success: "成功",
    Browse: "ブラウズ",
    orDropYourFileCsvXlsXlsxHere: "または、ファイル (CSV、XLS、XLSx) をここにドロップします",
    search: "検索",
    apply: "申し込み",
    select: "選択する",
    previous: "前",
    mandatory: "必須",
    dropYourFileHere: "または、ファイル (CSV、XLS、XLSx、PDF、Docx、PNG、JPEG) をここにドロップします",
    restoreDefault: "デフォルトを復元",
    pending: "保留中",
    completed: "完了しました",
    remove: "削除",
    update: "アップデート",
    removeFile: "ファイルの削除",
    uploadFile: "ファイルをアップロードする",
    pleaseChoosePreferedLanguage: "ご希望の言語を選択してください",
    edit: "編集",
    activate: "活性化",
    deactivate: "非アクティブ化",
    recievedOrders: "受注数",
    chartRepresentation: "チャートの表現",
    nameIsRequired: "名前は必須です",
    export: "輸出",
    noFilesAvailable: "利用可能なファイルがありません",
    selectDepartmentToshowRoles: "役割を表示する部門を選択してください",
    selectDepartmentWithActiveRoles: "アクティブな役割を持つ部門を選択してください",
    nameCanContainOnlyAlphabets: "名前にはアルファベットのみを含めることができます",
    nameMustBeLessThan15Chars: "名前は 30 文字未満にする必要があります",
    emailRequired: "メールアドレスは必須です",
    invalidEmailFormat: "無効な電子メール形式",
    mobNumReq: "携帯電話番号は必須です",
    invalidMobFormat: "携帯電話番号の形式が無効です。",
    passwordRequired: "パスワードが必要",
    departmentReq: "部門は必須です",
    roleReq: "役割は必須です",
    unableToUpdate: "更新できません",
    orignalName: "元の名前",
    uploadedDate: "アップロード日",
    fileName: "ファイル名",
    importNum: "輸入番号",
    languagePreferences: "言語の設定",
    pleaseTryAgainAfterSometime: "しばらくしてからお試しください",
    noChanges: "変更なし",
    nothingchanged: "何も変わっていません",
    pleaseChooseAnImageFile: "画像ファイルを選択してください",
    fileIsTooBigSelectUnder1MB: "ファイルが大きすぎます! ",
    phoneShouldHave10Chars: "電話番号は 10 文字にする必要があります",
    onlyCSVAllowed: "CSV ファイルのみが許可されます",
    loadingPleaseWait: "読み込み中。。。待って下さい",
    manager: "マネジャー",
    administrator: "管理者",
    Comingsoon: "近日公開",
    totalAnimals: "動物の総数",
    receivedOrders: "受注実績",
    drugs: "薬物",
    detailedAnalysis: "詳細な分析",
    barGraphRepOfActiveUsersAndDeactivateUsers: "アクティブ ユーザーと非アクティブ ユーザーの棒グラフ表示",
    barGraphRepOfRegAnimalsVsFarm: "登録動物と農場の棒グラフ表示",
    roleNumber: "役割番号",
    roleName: "役割名",
    active: "アクティブ",
    inactive: "非活性",
    admin: "管理者",
    addRole: "役割の追加",
    addRoles: "役割の追加",
    permissions: "権限",
    sr: "シニア",
    moduleName: "モジュール名",
    view: "意見",
    deptNo: "部署名番号",
    selectByCategory: "カテゴリ別に選択",
    weeklyAnalytics: "毎週の分析",
    pregnancy: "妊娠",
    analytics: "分析",
    calendar: "カレンダー",
    productName: "商品名",
    volumeSold: "販売量",
    recordPoints: "記録ポイント",
    inStock: "在庫あり",
    revenue: "収益",
    stockStatus: "在庫状況",
    barChart: "棒グラフ",
    lineChart: "折れ線グラフ",
    indexReturns: "インデックスの戻り値",
    chart: "チャート",
    time: "時間",
    production: "製造",
    customization: "カスタマイズ",
    recordsPerPage: "ページあたりのレコード数",
    noDataAvailable: "データなし",
    reporting: "報告",
    optional: "オプション",
    note: "ノート",
    notes: "ノート",
    date: "日にち",
    kG: "KG",
    weight: "重さ",
    type: "タイプ",
    lessthan3Month: "3か月未満",
    lessthan6Month: "6か月未満",
    lessthan7Month: "7か月未満",
    lastWeek: "先週",
    thisWeek: "今週",
    lessthanOneYear: "1 年未満",
    lessthanTwoYear: "2年未満",
    lessthanThreeYear: "3 年未満",
    lessthanFourYear: "4 年未満",
    yes: "はい",
    no: "いいえ",
    of: "の",
    notSpecified: "指定されていない",
    days: "日々",
    day: "日",
    aDay: "一日",
    years: "年",
    year: "年",
    unit: "ユニット",
    units: "単位",
    to: "に",
    profile: "プロフィール",
    logOut: "ログアウト",
    Unit: "ユニット",
    otherSettings: "その他の設定",
    somethingWentWrong: "何か問題が発生しました。",
    toDo: "やるべきこと",
    loadingData: "データのロード...",
    taskNumber: "タスク番号",
    taskName: "タスク名",
    startDate: "開始日",
    dueDate: "期日",
    reason: "理由",
    quantity: "量",
    cost: "料金",
    noRecordFound: "レコードが見つかりませんでした",
    dailyUpdates: "毎日の更新",
    weeklyUpdates: "毎週の更新",
    moduleAccessed: "アクセスされたモジュール",
    typesOfAccess: "アクセスの種類",
    userId: "ユーザーID",
    lastLogin: "前回のログイン",
    terminalID: "端末ID",
    geographicalAccessPoint: "地理的アクセスポイント",
    iPAddress: "IPアドレス",
    fileAccessed: "アクセスされたファイル",
    functionAccessed: "アクセスされた機能",
    webPageURL: "ウェブページのURL",
    accessType: "アクセスタイプ",
    unsuccessfulLoginAttempts: "失敗したログイン試行",
    customerAddress: "顧客の住所",
    orderdate: "注文日",
    postageDate: "郵便日",
    postID: "投稿ID",
    packingTechnician: "梱包技術者",
    packingTechnicia: "梱包技術者",
    packEdit: "パック編集",
    batchNumber: "バッチ番号",
    collectionTechnician: "収集技術者",
    collectionTechnicia: "収集技術者",
    preparationTechnicia: "準備技術者",
    preparationTechnician: "準備技術者",
    approvedManually: "手動で承認されました",
    researcher: "研究者",
    dateOfApproval: "承認日",
    approvalEdit: "承認編集",
    searchByAllExceptDate: "日付を除くすべてで検索",
    approval: "承認",
    collection: "コレクション",
    postage: "送料",
    pack: "パック",
    straws: "ストロー",
    createdAt: "作成日",
    sireID: "種牡馬ID",
    economicIndexValue: "経済指標値",
    latestCollectionDate: "最新の収集日",
    locationId: "ロケーションID",
    lastUpdated: "最終更新",
    print: "印刷する",
    save: "保存",
    tax: "税",
    phoneNo: "電話番号",
    exportAsPDF: "PDFとしてエクスポート",
    statusUpdated: "ステータスが更新されました",
    statusNotUpdated: "ステータスが更新されていません",
    inProgress: "進行中",
    assignedTo: "に割り当てられた",
    taskId: "タスクID",
    createdDate: "作成日",
    numberOfAnimals: "動物の数",
    healthRecordSubmittedSuccess: "健康記録が正常に送信されました",
    healthRecordSubmitted: "健康記録が提出されました。",
    InseminationRecordSubmittedSuccesful: "授精記録が正常に提出されました",
    inseminationRecordSubmitted: "授精記録が提出されました。",
    actionListDailyTask: "アクションリスト - 毎日のタスク",
    sinceLastYear: "去年から",
    sinceLastQuarter: "前四半期以降",
    sinceLastMonth: "先月から",
    sinceLastWeek: "先週から",
    drugWithdrawPeriod: "休薬期間",
    diagnosisName: "診断名",
    animalWithNoGenetype: "この動物には遺伝子型データが登録されていません。",
    nameOfPreviousOwner: "前の所有者の名前",
    avatarSize: "アバターのサイズは 1 MB 未満である必要があります。",
    testDestination: "テスト先",
    animalNotAdded: "動物は追加されていません",
    registerationSuccessful: "登録に成功",
    backToAnimalList: "動物リストに戻る",
    addAnotherAnimal: "別の動物を追加する",
    animalDetailsUpdated: "動物の詳細が正常に更新されました",
    animalUpdatedSuccessfully: "動物が正常に更新されました",
    animalNotUpdated: "動物は更新されていません",
    notMember: "会員ではありませんか？",
    requestAccess: "アクセスをリクエストする",
    typePassword: "パスワードを入力してください。",
    minChars: "最低6文字",
    typeConfirmPassword: "確認用のパスワードを入力します",
    passConfig: "パスワードの確認が一致しません。",
    invalidEmailMobile: "無効な電子メール/モバイル形式",
    passwordNotEmpty: "パスワードを空にすることはできません",
    passwordLength: "パスワードの長さは 8 文字未満にすることはできません",
    cityVillage: "市・村",
    districtRegion: "地区・地域",
    alreadyHaveAnAccount: "すでにアカウントをお持ちですか?",
    genetypeUpdated: "ジェノタイプが更新されました",
    genetypeNotUpdated: "GenoType が更新されていません",
    sellTrade: "販売/取引",
    milkingDevon: "販売のためのデボン繁殖ストックの搾乳",
    detailedDescription: "詳細な説明",
    longPara: "アメリカのデボン雄牛の未経産牛と牛の搾乳。",
    contactSeller: "販売者に連絡する",
    enterListingTitle: "出品タイトルを入力してください",
    livestocktype: "家畜の種類",
    uploadImage: "画像をアップロードする",
    mobilePhone: "携帯電話番号",
    myLivestock: "私の家畜",
    livestockObservations: "家畜の観察",
    selectFromRegisteredAnimals: "登録動物一覧から選ぶ",
    selectOption: "オプションの選択",
    selectTypeObservation: "観測の種類を選択してください",
    attachVeteinaryDocument: "獣医師の書類を添付してください",
    addsensorReading: "センサー読み取り値を追加",
    myDocument: "私の文書",
    enterAKeyword: "キーワードを入力してください",
    documentType: "ドキュメントタイプ",
    registerEditLivestock: "家畜の登録・編集",
    editLivestockProfile: "家畜プロフィールの編集",
    copy: "コピー",
    dateOfRegister: "登録日",
    livestockType: "家畜の種類",
    registerNewLivestock: "新しい家畜を登録する",
    enterUniqueTag: "一意のタグを入力してください",
    color: "色",
    gender: "性別",
    male: "男",
    female: "女性",
    damm: "ダム",
    siree: "種牡馬",
    dateOfSaleAuction: "販売日/オークション販売日",
    auctionRecord: "デスリストのオークション記録",
    distinguishingFeatures: "特徴",
    keywordListing: "キーワードまたはリスティングID",
    adType: "広告の種類",
    activeListingFund: "1 件のアクティブなリストが見つかりました",
    setupSensors: "センサーのセットアップ",
    serialNumber: "シリアルナンバー",
    sensorLocation: "センサーの位置",
    sensorType: "センサーの種類",
    installationDate: "設置日",
    ExpirationDate: "有効期限",
    addGeo: "地理位置情報の追加",
    addMoreSensors: "センサーを追加する",
    trackAndTrace: "追跡と追跡",
    createNewShipment: "新しい出荷を作成する",
    workflowReference: "ワークフローリファレンス",
    invoiceDate: "請求書の日付",
    trackShipment: "出荷を追跡する",
    totalShipments: "総出荷数",
    activeShipment: "アクティブな出荷数",
    completedObjectives: "完了した目標",
    processedPayments: "処理された支払い",
    pointOfDestination: "目的地",
    sellerInformation: "販売者情報",
    selectSellerConsignor: "販売者/荷主を選択してください",
    pointOfOrigin: "原点",
    buyerInfo: "購入者情報",
    selectBuyerConsignor: "購入者/荷主を選択してください",
    addSensorTriggers: "センサートリガーの追加",
    processPayments: "支払いの処理",
    defineShippingContract: "配送契約の定義",
    addDigitize: "追加",
    currentlyOnFarm: "現在農場にいる",
    addSire: "種牡馬を追加",
    addApproval: "承認の追加",
    addCollection: "コレクションの追加",
    addStraws: "ストローを追加する",
    addPack: "パックの追加",
    addPostage: "送料を追加する",
    searchBySire: "種牡馬で検索",
    anyDataChangeMightBeLost: "データの変更は失われる可能性があります",
    wouldYouLikeToSaveOrWantToLeaveWithoutSaving: "保存しますか、それとも保存せずに終了しますか?",
    leave: "離れる",
    stay: "止まる",
    animalFarm: "動物農場",
    animalFarmH: "動物農場",
    animalOrigin: "動物由来",
    animalOriginH: "動物由来",
    farmOfOrigin: "原産地農場",
    farmOfOriginH: "原産地農場",
    selectFarm: "ファームを選択してください",
    searchFarm: "サーチファーム",
    confirmation: "確認",
    proceed: "続行",
    ok: "OK",
    animal: {
      tagH: "鬼ごっこ",
      tagNumberH: "タグ番号: 番号だけでなく色も追加できます。",
      goveRegNoH: "政府機関への登録時に付与される番号",
      birthWeightH: "子牛の出生体重",
      birthEaseH: "家畜の出産は自然なプロセスですが、ダムが農民/牧畜民の援助を必要とする出産の問題が発生する場合があります。",
      birthFarmH: "動物の起源/誕生の農場。",
      surrogateDamH: "ドナー雄とドナー雌からの受精卵がさらなる発育のために移植される雌牛のID。",
      ownerH: "これは動物の飼い主の名前です。",
      damH: "動物のメスの親/母親の ID。",
      sireH: "動物の雄の親/父親の ID。",
      breedH: "品種とは、均一な外観 (表現型)、均一な行動、および/または同じ種の他の生物と区別するその他の特徴を持つ、家畜の特定のグループです。",
      conceptionMethodH: "その動物がどのようにして誕生したのか。",
      genderH: "動物の性別。",
      dobH: "動物の生年月日。",
      operatorH: "この動物の情報を入力する人の名前。",
      removalFarmH: "動物の撤去農場 ",
      dateOfRemovalH: "動物の撤去日",
      destinationOfRemoval: "撤去された動物の目的地",
      reasonOfRemovalH: "動物の駆除の理由",
      trackingNumberH: "動物が移動されるときに動物に割り当てられる番号",
      brandH: "ブランド - 単に牛に焼き付けられた永久的なマークです。",
      tattoH: "動物のタトゥー。",
      hornStatusH: "動物が角を切除されているかどうか。",
      animalOriginH: "動物の原産国。",
      previousOwnerH: "成熟した動物の場合は、その動物の前の所有者の名前。",
      twinH: "このフィールドには、動物に双子がいるかどうかが示されます。",
      regBreedAssoNoH: "品種協会/団体への登録。",
      breedAssoNameH: "動物が登録された協会/団体の名前",
      breederH: "これは動物を供給した組織の名前です。",
      breeder: "ブリーダー",
      noteH: "動物に関する重要な注意事項。",
      accuracyWeight_for_field: "精度の重み",
      conception: "概念",
      addAnAnimal: "動物を追加する",
      addAnimal: "動物を追加する",
      registerAnAnimal: "動物を登録する",
      uploadAnAnimal: "動物をアップロードする",
      animalRegistration: "動物登録",
      animalDetails: "動物の詳細",
      tag: "鬼ごっこ",
      tagNumber: "タグ番号",
      govtRegNumber: "政府",
      birthWeight: "出生体重 (ポンド)",
      birthEase: "出産のしやすさ",
      birthFarm: "バースファーム",
      surrogateDam: "代理ダム",
      owner: "オーナー",
      ownershipType: "所有権の種類",
      animalDiseaseRecord: "動物の病気の記録",
      govtReg: "政府",
      regDate: "登録日",
      dam: "ダム",
      sire: "種牡馬",
      heifer: "雌牛",
      steer: "ステアリング",
      calf: "ふくらはぎ",
      farmHerd: "農場/群れ",
      femaleCalf: "雌の子牛",
      maleCalf: "雄の子牛",
      newCalves: "新しい子牛",
      breed: "繁殖",
      conceptionMethod: "構想方法",
      gender: "性別",
      dateOfBirth: "生年月日",
      operator: "オペレーター",
      animalRemovedFarm: "動物の撤去農場",
      dateOfAnimalRemoval: "動物の撤去日",
      destinationOfRemovedAnimal: "撤去された動物の行き先",
      reasonOfRemoval: "削除の理由",
      optionalAnimalInformation: "オプションの動物情報",
      animalPicture: "動物の絵",
      trackingNumber: "追跡番号",
      brand: "ブランド",
      tatto: "入れ墨",
      hornStatus: "ホーンのステータス",
      animalOrigin: "動物由来",
      previosOwner: "前のオーナー",
      twin: "ツイン",
      InABreedAssociation: "登録",
      nameOfBreedAssociations: "犬種協会の名称",
      breedAssociations: "犬種協会",
      breederSupplier: "ブリーダー（サプライヤー）",
      importAnimal: "輸入動物",
      loadingAnimals: "動物を読み込んでいます...お待ちください",
      totalRegAnimals: "合計登録",
      totalPregnantAnimals: "妊娠中の動物の総数",
      pregnantAnimalHistory: "妊娠中の動物の歴史",
      dailyAnimalPregnancyUpdates: "動物の妊娠に関する毎日の最新情報",
      animalHistory: "動物の歴史",
      dailyAnimalUpdates: "毎日の動物の最新情報",
      totalPregnant: "合計妊娠中",
      totalNewBorn: "合計新生児",
      searchByIDGOVRegTag: "ID、GOV Reg、タグによる検索",
      noANIMALAVAILABLE: "動物はいません",
      associationNumber: "協会番号",
      associationName: "協会名",
      destinationName: "宛先名",
      plastic: "プラスチック",
      metal: "金属",
      naturalMating: "自然交配",
      artificialInsemination: "人工授精",
      embryoTransfer: "胚移植",
      noAssistance: "援助なし",
      someAssistance: "多少の援助",
      mechanicalAssistance: "機械的支援",
      aCesareanSection: "帝王切開",
      abnormalDelivery: "異常分娩",
      male: "男",
      female: "女性",
      castrated: "去勢済み",
      sale: "セール",
      slaughter: "虐殺",
      death: "死",
      theft: "盗難",
      other: "他の",
      horned: "角のある",
      polled: "投票済み",
      dehorned: "角を落とした",
      details: "詳細",
      performance: "パフォーマンス",
      geneticWorth: "遺伝的価値",
      healthRecord: "健康記録",
      genotypeData: "遺伝子型データ",
      reminders: "リマインダー",
      activityLog: "活動記録",
      activityLogDetails: "アクティビティログの詳細",
      editAnimal: "動物の編集",
      familyInfo: "家族情報",
      breedInfo: "品種情報",
      identification: "身元",
      removalInfo: "削除情報",
      iDOfAnimalDam: "動物の母のID。",
      iDOfAnimalSire: "動物の種牡馬の ID。",
      iDOfDamEmbryoUsed: "胚が使用された母母の ID。",
      animalHasATwinOrNot: "動物に双子がいるかどうか。",
      breedType: "犬種の種類",
      breedOfTheAnimal: "これはその動物の品種です。",
      regBreedAssociations: "品種協会/団体への登録。",
      nameOfAssociationsSocieties: "動物が登録されている団体/団体の名前。",
      nameOfTheOrgSuppliedAnimal: "これは動物を供給した組織の名前です。",
      countryOriginAnimal: "動物の原産国。",
      birthFarmID: "バースファームID",
      farmIDAnimalBorn: "動物が生まれた農場のID。",
      currentOwner: "現在の所有者",
      nameOfOwnerAnimal: "これは動物の飼い主の名前です。",
      registrationDate: "登録日",
      previousOwner: "前の所有者",
      nameOfOperator: "オペレータ名",
      dateAnimalRemoved: "動物が撤去された日付。",
      destinationPlaceRemovedAnimal: "撤去された動物の目的地",
      namePersonFillAnimalInformation: "この動物の情報を入力する人の名前。",
      reasonOfAnimalRemoval: "動物の駆除の理由",
      reasonWhyTheAnimalIsRemoved: "動物が撤去される理由",
      processingDate: "処理日",
      DateInformationFilledChanged: "現在の情報が入力または変更された日付。",
      animalID: "動物ID",
      UniqueIdAnimal: "これは動物の一意の ID です。",
      plasticTagNumber: "プラスチックタグ番号",
      numberAnimalTag: "動物タグの番号。",
      rFTagNumber: "RFタグ番号",
      numberAnimalRFTag: "動物RFタグの番号。",
      govtRegNumb: "政府",
      govtRegistrationNumber: "個人の名前と住所、プロセスサービスの個人の代理人、実行される活動の場所、および個人が提供するサービスの説明を含む可能性のある識別情報の詳細。",
      numberAssignedAnimalIsRemoved: "追跡番号は、動物の活動を追跡するために使用される動物の ID の 1 つです。",
      dateOfAnimalRegistration: "動物登録日",
      stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal: "ブランド - 単に牛に焼き付けられた永久的なマークです。",
      tattoOnAnimal: "動物のタトゥー。",
      whetherTheAnimalIsDehorned: "動物が角を切除されているかどうか。",
      milkingAnimals: "動物の乳搾り",
      studAnimals: "スタッドアニマル",
      animalInseminationRecord: "動物の授精記録",
      numOfStrawsOrdered: "注文したストローの数",
      totalNumOfStraws: "ストローの総数",
      strawId: "ストローID",
      addSireAutomation: "サイアーオートメーションの追加",
      addApprovalAutomation: "承認自動化の追加",
      addCollectionAutomation: "収集自動化の追加",
      addStrawsAutomation: "ストロー自動化の追加",
      addPackAutomation: "パックオートメーションの追加",
      addPostageAutomation: "郵便自動化を追加する",
      searchBySire: "検索による検索",
      numberOfProgenies: "子孫の数",
      sireEdit: "種牡馬編集",
      searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId: "ストロー ID、ストローの総数、バッチ番号、ロケーション ID による検索",
      searchByPackIdNumberOfStrawsOrderedPackingTechnicia: "パック ID、注文したストローの数、梱包技術者による検索",
      searchByCollectionAndPreparationTechnicia: "採取・作成技術者から探す",
      registerSemenAutomation: "精液自動化の登録",
      addSemenAutomation: "精液自動化を追加",
      strawAutomationRegistered: "ストロー自動化登録済み",
      strawAutomationRegisteredNotRegistered: "ストローオートメーション 登録済み 未登録",
      sireAutomationRegistered: "サイアーオートメーション登録済み",
      sireAutomationNotRegistered: "Sire Automation が登録されていません",
      postageAutomationIsRegistered: "郵便自動化が登録されています",
      postageAutomationNotRegistered: "郵便自動化が登録されていません",
      packAutomationIsRegistered: "パックオートメーションが登録されました",
      packAutomationNotRegistered: "パックオートメーションが登録されていません",
      postageAutomationIsUpdated: "郵便自動化が更新されました",
      postageAutomationNotUpdated: "郵便自動化が更新されていない",
      packAutomationIsUpadted: "パックオートメーションが更新されました",
      packAutomationNotUpadted: "パックオートメーションが更新されていない",
      collectionAutomationUpdated: "収集の自動化が更新されました",
      collectionAutomationNotUpdated: "収集の自動化が更新されていない",
      approvalAutomationIsUpdated: "承認自動化が更新されました",
      approvalAutomationIsNotUpdated: "承認自動化が更新されない",
      collectionAutomationRegistered: "収集の自動化が登録されました",
      collectionAutomationNotRegistered: "収集の自動化が登録されていません",
      approvalAutomationIsRegistered: "承認自動化が登録されました",
      approvalAutomationIsNotRegistered: "承認自動化が登録されていません",
      strawAutomationUpdated: "ストロー自動化が更新されました",
      strawAutomationIsNotUpdated: "ストローオートメーションが更新されない",
      searchSire: "種牡馬を探す",
      strawsEdit: "ストロー編集",
      nextAnimals: "次の動物",
      performanceInfo: {
        milk: "牛乳",
        liveweight: "ライブウェイト",
        score: "スコア",
        fertility: "受胎能力",
        measurements: "測定",
        dailyProteinYield: "1日のタンパク質収量",
        amountProteinMilkCowDay: "特定の日に牛から得られた牛乳に含まれるタンパク質の量。",
        dailyMilkYield: "一日の乳量",
        volumeMilkCowDay: "特定の日に特定の牛から得られる牛乳の量。",
        dailyFatYield: "毎日の脂肪収量",
        amountFatMilkCowDay: "特定の日に牛から得られた牛乳に含まれる脂肪の量。",
        dailyProteinContent: "1日あたりのたんぱく質含有量",
        dailyFatContent: "一日あたりの脂肪含有量",
        milkLactose: "牛乳乳糖",
        amountLactoseMilk: "牛乳に含まれる乳糖の量。",
        milkUrea: "乳尿素",
        indicatorAmountCrudeProtein: "牛の飼料中の粗タンパク質の量を示す指標",
        lactationNumber: "授乳数",
        ordinalNumLactation: "授乳の序数。",
        lengthOfLactation: "授乳期間（例：23日）",
        lactationLength: "授乳期間の長さ",
        milkingFrequency: "搾乳頻度",
        frequcnyOfMilking: "搾乳の頻度（例：1日2回）",
        liveWeightInformation: "生体重情報",
        currentWeight: "現在の体重",
        weightAnimal: "動物の体重。",
        postWeaningGain: "離乳後の増加",
        dailyGainInAnimalWeightWeaning: "離乳後の動物の体重の毎日の増加。",
        weaningWeight: "離乳時の体重",
        weightAnimalMeasuredWeaning: "離乳当日に測定した動物の体重。",
        averageDailyGain: "1 日あたりの平均利益",
        averageAmountWeightAnimalGainFeedingPeriod: "給餌期間中に動物が毎日増加する平均体重",
        carcassWeight: "枝肉重量",
        weightAnimalsHideInternalOrgansRemoved: "頭、皮、内臓を取り除いた後の動物の重量。",
        weightAtCalving: "分娩時の体重",
        weightAtTheTimeOfCalving: "分娩時の体重。",
        yearlingWeight: "当歳体重",
        weightYearOldAnimal: "1歳の動物の体重。",
        somaticCellScore: "体細胞スコア",
        somaticCellScoreIndicatorMastitis: "乳房炎の指標としての体細胞スコア。",
        lastUpdate: "最後の更新",
        bodyConditionScore: "体調スコア",
        scoreAnimalFat: "脂肪の量に関する動物のスコア。 ",
        teatScore: "乳首スコア",
        scoreMeasureingShapeTeats: "乳頭サイズスコアは、乳頭の長さと周囲の主観的な評価であり、9 (非常に小さい) から 1 (非常に大きい) の範囲です。",
        udderScore: "乳房停止スコア",
        scoreMeasureingShapeOfUdder: "乳房の形状を測定するスコア (1 ～ 9 スコア)。",
        whetherAnimalEasyBirthDifficult: "家畜の出産は自然なプロセスですが、ダムが農民/牧畜民の援助を必要とする出産の問題が発生する場合があります。",
        totalLongevity: "総寿命",
        survivalLactationTraitCowCulledBreeding: "授乳1回目から5回目まで生存。",
        docility: "従順",
        circumferenceBullScrotal: "雄牛の陰嚢の周囲",
        intervalSuccessInsemination: "最初の授精が成功するまでの間隔。",
        ageAtFirstCalving: "初産時の年齢",
        ageCowCalving: "最初の出産の牛の年齢は何歳ですか。",
        calvingInterval: "分娩間隔",
        periodCalving: "一回の出産から次の出産までの期間。",
        scrotalCircumference: "陰嚢周囲",
        estrusDetection: "発情検知",
        trackingBehaviorAnimalDetectingEstrus: "牛の発情を検知するための動物の移動行動の追跡。",
        presenceOfEstrus: "発情期の存在",
        isCowInEstrusStage: "牛が発情期にあるとき、または発情期にないとき",
        matureWeight: "成熟した体重",
        weightAnimalDefinedAge: "定義された年齢における動物の体重。",
        matureHeight: "成熟した身長",
        heightAnimalDefinedAge: "定義された年齢における動物の身長。",
        footClawSet: "フットクローセット",
        shapeAnimalClaw: "動物の爪の形。",
        pulmonaryArterialPressure: "肺動脈圧",
        animalBloodPreasure: "動物の血液の貴重品。",
        footAngle: "足の角度",
        shapeAnimalFoot: "動物の足の形。",
        ribEyeArea: "リブアイエリア",
        amountRibEyeArea: "リブアイ部分の量。",
        ultrasoundFat: "超音波脂肪",
        measureFatAmount: "脂肪量の測定。",
        ultrasoundIntramuscularFat: "超音波筋肉内脂肪",
        ultrasoundRibEyeArea: "肋骨領域の超音波検査",
        measureRibeyeArea: "リブアイ部分の寸法。",
        fatThickness: "脂肪の厚さ",
        amountAnimalBackFat: "動物の背脂の量。",
        marbling: "霜降り",
        marballingMeasurement: "霜降りは、筋肉内および筋線維束の間に蓄積する、目に見える不飽和（健康な）筋肉内脂肪です。",
        dryMatterIntake: "乾物の摂取量",
        amountFeedAnimalConsumesAMoisture: "水分を含まないベースで、動物が 1 日に摂取する飼料の量。"
      },
      feedsName: "フィード名",
      feedName: "フィード名",
      firstFeedQuantity: "最初の給餌量",
      additionalFeed: "追加飼料",
      cloversRyeGrasses: "クローバー、ライ麦草",
      greenFodderHayLegumes: "緑色飼料、干し草、マメ科植物",
      feedsRegisteredSuccessfully: "フィードが正常に登録されました",
      feedsNotRegistered: "フィードが登録されていません",
      fEEDQUANTITY: "給餌量",
      feedQuantity: "給餌量",
      fEEDNAME: "フィード名",
      nOFEEDINFOAVAILABLE: "フィード情報はありません",
      searchByFeedName: "フィード名で検索",
      loadingFeedInfo: "フィード情報を読み込み中...お待ちください",
      todayFeedInfo: "今日のフィード情報",
      feedInfo: "フィード情報",
      loremIpsumDolorSitAmet: "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
      geneticWorthInfo: {
        breedingValueEconomicIndex: "この育種価を経済指標の計算に使用するかどうか。",
        dailyProteinYieldUsed: "1 日に使用されるタンパク質の収量",
        weightAssignedBreedingDailyProteinYield: "「毎日のタンパク質収量」に対応する育種価に割り当てられる重み。",
        dailyProteinYieldWeight: "1 日あたりのタンパク質収量重量",
        rankAnimalInRelationshipEconomicIndex: "経済指標との関係における動物のランク。",
        economicIndexRank: "経済指標ランク",
        percentileEconomicIndexFall: "経済指標が該当するパーセンタイル。",
        economicIndexPercentile: "経済指標パーセンタイル",
        accuracyOfEconomicIndex: "経済指標の精度。",
        economicIndexAccuracy: "経済指標の精度",
        weightedAverageOfBreedingValues: "育種価の加重平均。",
        economicIndex: "経済指標",
        rankOfAnimalInRelationshipBreeding: "対応する繁殖価額との関係における動物のランク。",
        dailyProteinYieldBreedingValueRank: "一日たんぱく質収量育種価ランキング ",
        percentileBreedingFalls: "育種価が該当するパーセンタイル。",
        dailyProteinYieldBreedingPercentile: "一日当たりのタンパク質収量育種価値パーセンタイル ",
        accuracyEstimatedBreeding: "推定育種価の精度。",
        dailyProteinYieldBreedingAccuracy: "毎日のタンパク質収量育種値の精度",
        estimatedBreedingTraitDailyProteinYield: "形質の推定育種価額「一日あたりのタンパク質収量」。",
        dailyProteinYieldBreedingValue: "1 日あたりのタンパク質収量の繁殖値 ",
        pathToTheDirectoryScriptsBreeding: "育種価の計算に使用されるスクリプトを含むハード ドライブ上のディレクトリへのパス。",
        scriptsPath: "スクリプトパス",
        softwarePackageBreeding: "育種価を計算するために使用されるソフトウェアパッケージ。",
        breedingValueSoftware: "育成価値ソフトウェア",
        methodCalculateBreeding: "育種の計算に使用された方法",
        breedingValueMethod: "育種価法",
        trait: "特性",
        tools: "ツール",
        geneticWorth: "遺伝的価値",
        dailyProteinYield: "1日のタンパク質収量",
        breedingValue: "繁殖価値",
        breedingValueBIFAccuracy: "育種値 BIF 精度",
        breedingValuePercentile: "育種価パーセンタイル",
        breedingValueRank: "育成価値ランク",
        checkLTD: "チェック株式会社",
        ultrasoundDiagnostic: "超音波診断",
        selectYieldUsed: "使用される収量を選択してください",
        softwareName: "ソフトウェア名",
        animalGenWorthUpdatedSuccessfully: "動物の世代の価値が正常に更新されました"
      },
      addNote: "メモを追加",
      enterNote: "注記を入力してください",
      noteIsRequired: "注記は必須です",
      noteMustBeLessThan50Characters: "注は 50 文字未満である必要があります",
      noteAdded: "注記を追加しました",
      noteNotAdded: "注は追加されていません",
      noteForAnimal: "動物用のメモ。",
      noNoteFoundForThisAnimal: "この動物に関するメモは見つかりませんでした。",
      inseminationData: "授精データ",
      nameOfInseminator: "授精者の名前",
      activity: "アクティビティ",
      searchByNameActivity: "名前、活動で検索",
      searchByTaskNameNumber: "タスク名、番号で検索",
      inseminationDate: "授精日",
      genotypeDataInfo: {
        genotypeAnimalID: "遺伝子型動物ID",
        iDTubeBloodSampleAnimalNumberGenotypingService: "これは、動物から採取された血液サンプルが入ったチューブの ID、またはいくつかのジェノタイピング サービスです。",
        geneticTechnicianName: "遺伝子技術者名",
        NameTechnicianBloodSamplesAnimal: "これは動物から血液サンプルを採取した技術者の名前です",
        sNPData: "SNPデータ",
        genotypingServiceNote: "ジェノタイピングサービスノート",
        InfoGenotypingGenotypingTechnology: "ジェノタイピング会社の名前、使用されたジェノタイピング技術、ジェノタイピングの日付など、ジェノタイピングに関連するすべての情報",
        numberOfSNPs: "SNPの数",
        numberOfSNPsAnimalGenotyped: "動物の遺伝子型が特定された SNP の数",
        nameOfTheDrug: "薬の名前",
        animalGenoDataUpdatedSuccessfully: "動物遺伝子データが正常に更新されました",
        animalGenoDataNotUpdated: "動物遺伝子データが更新されていない",
        animalIDIsRequired: "動物IDが必要です",
        techNameIsRequired: "技術。",
        onlyAlphabetsAreAllowed: "アルファベットのみ使用できます",
        genoDataIsRequired: "遺伝子データが必要です",
        serviceNoteIsRequired: "サービスノートは必須です",
        sNPIsRequired: "SNPは必須です"
      },
      healthRecordInfo: {
        treatment: "処理",
        treatmentTakenAnimal: "動物に対してどのような治療が行われたのか。",
        reasonOfTreatment: "治療の理由",
        reasonForTreatment: "治療の理由",
        whatReasonOfTreatment: "治療の理由は何ですか。",
        treatmentDate: "治療日",
        dateOfTreatment: "治療日。",
        diagnosis: "診断",
        nameDiagnosedDiseaseConditionSymptoms: "診断された疾患名または状態または主な症状",
        drugID: "薬剤ID",
        iDOfDrugWhichIsGivenToAnimal: "動物に投与される薬剤のID。",
        drugName: "薬剤名",
        nameDrugAnimal: "動物に投与される薬剤の名前。",
        drugWithdrawalPeriod: "休薬期間",
        timeAdministrationDrugAnimalMeatMilkHumanConsumption: "動物に薬剤を投与してから、人間が消費する肉または牛乳の安全性を確保するために必要な時間",
        attendingVeterinarian: "担当獣医師",
        qualifiedPersonCaseAnimal: "症例/動物を見た資格のある人",
        packID: "パックID",
        iDPackTreatment: "治療に使用したパックのID",
        veterinarianName: "獣医師名",
        animalNoHealthRecord: "この動物には健康記録がありません。",
        addHealthRecord: "健康記録を追加",
        healthStatus: "健康状態",
        loadingDiseasesPleaseWait: "病気を読み込んでいます...お待ちください",
        animalDiseaseRecord: "動物の病気の記録",
        animalHealthRecord: "動物の健康記録",
        animalTreatmentRecord: "動物の治療記録",
        loadingHealthData: "健康データをロードしています...",
        healthRecord: "健康記録",
        nameOfDiagnosis: "診断名",
        treatmentName: "治療名",
        drugGivenBy: "薬物投与者",
        recessiveDiseases: "劣性疾患",
        recessiveDiseasesMessage: "この雄牛が保因している劣性疾患の対立遺伝子はどれですか"
      },
      conceptionInfo: {
        addNewConception: "新しい概念を追加する",
        semenEmbryo: "精液・胚",
        pregnancyCheck: "妊娠チェック",
        birthInfo: "出生情報",
        searchByInseminatorOrganisationBreedingConception: "授精者名、団体名、飼育サービス番号、受胎方法で検索",
        deliveryDate: "配送日",
        calfId: "子牛のID",
        birthDayOldWeight: "出生（生後）体重",
        searchByBirthEase: "生まれやすさから探す",
        searchPregnancyCheckOperatorMethod: "妊活チェック事業者、妊活チェック方法から探す",
        pregnancyCheckDate: "妊娠検査日",
        conceptionSuccess: "構想の成功",
        pregnancyCheckOperator: "妊娠チェックオペレーター",
        pregnancyCheckMethod: "妊娠チェック方法",
        recentlyPregnant: "最近妊娠しました",
        pregnancyConfirmationDate: "妊娠確認日",
        pregnancyRate: "妊娠率",
        timePeriodOfPregnancy: "妊娠期間",
        semenProduction: "精液の生産",
        embryoProduction: "胚の生産",
        semen: "精液",
        embryoTransferDate: "胚移植日",
        daysOfPregnancy: "妊娠の日数",
        searchSireEmbryoSurrogate: "種牡馬ID、胚組織名、代理母馬品種による検索",
        selectDate: "日付を選択してください",
        orgnisationNameContainNumber: "組織名には数字を含めないでください",
        selectBirthEase: "誕生のしやすさを選択してください",
        selectUnit: "単位を選択してください",
        animalConceptionAddedSuccessfully: "動物の受胎が正常に追加されました",
        postageCustomerName: "送料のお客様名",
        searchByPostageCustNameCustAddPostId: "郵便料金の顧客名、顧客住所、郵便番号で検索",
        dateOfSemenCollection: "精液採取日",
        dateOfSemenPreparation: "精液調製日",
        semenMotility: "精液の運動性",
        semenConcentration: "精液濃度",
        postageEdit: "送料編集",
        enterSireId: "種牡馬IDを入力してください",
        selectEmbryoOrganisation: "胚組織の選択",
        matingDateH: "自然交配または人工授精のいずれかの受胎日。",
        inseminatorNameH: "授精プロセスを実行する人（獣医師/技師）",
        orgNameH: "AI用精液ストローを提供する団体名または企業名",
        brServiceNumH: "繁殖数の記録（例：1回目、2回目、3回目）",
        conceptionMethodH: "動物が妊娠する方法は妊娠の始まりであり、精子による卵子の受精によって特徴付けられます。",
        sireIdH: "動物の雄の親/父親のID",
        damIdH: "動物のメスの親/母親の ID。",
        sarogatedDamH: "ドナー雄とドナー雌からの受精卵がさらなる発育のために移植される雌牛のID。",
        embOrgNameH: "胚の組織名",
        sarogateDamBreedH: "代理品種の日付",
        sireBreedH: "種牡馬の種類（ブラフマン、ボラン）",
        pregCheckDateH: "牛の妊娠は、超音波検査と血液検査を使用して早ければ 30 日以内に検出できます。触診法を使用して牛が妊娠していると特定するには、多くの場合、牛が少なくとも妊娠 35 ～ 50 日である必要があります。",
        conceptionSuccessH: " ウシでは、受精率は 90%、平均出産率は約 55% であり、これは胚胎児死亡率が約 35% であることを示しています (Diskin et al., 2006)。",
        pregnancyCheckOperatorH: "獣医師と動物専門技術者がこれらのサービスを農家に提供するのが最も一般的です。",
        pregnancyCheckMethodH: "牛の妊娠診断に最も頻繁に使用される 2 つの方法は、生殖管 (直腸内) の手動触診と生殖管の経直腸的超音波検査です。",
        deliveryDateH: "出産が行われた日",
        calfIdH: "生まれたばかりの子牛のID",
        birthEaseH: "家畜の出産は自然なプロセスですが、ダムが農民/牧畜民の援助を必要とする出産の問題が発生する場合があります。",
        birthDayOldWeightH: "生まれた日の動物の体重または生後1日の鳥の体重",
        customerAddress: "顧客の住所"
      },
      all: "全て",
      ungrouped: "グループ化されていない動物",
      active: "グループ化された動物",
      updateAnimal: "動物を更新する"
    },
    dashboardS: {
      dailyActivities: "日々の活動",
      pendingTasks: "保留中のタスク",
      performanceOfGeno: "遺伝子型のパフォーマンス",
      breed: "繁殖",
      chromosome: "染色体",
      seqChange: "シーケンスチェンジ",
      inheritance: "継承",
      diseaseName: "病名",
      refSequence: "参照配列",
      pubmedRef: "Pubmed リファレンス",
      matingDate: "交配日",
      inseminatorName: "授精者名",
      orgName: "組織名",
      brServiceNum: "繁殖サービス番号",
      conceptionMethod: "構想方法",
      semEmbInfo: "精液・胚情報",
      sireId: "種牡馬ID",
      damID: "ダムID",
      srgDamId: "サロゲートダムID",
      embOrgName: "胚組織",
      srgDamBreed: "代理ダムの品種",
      sireBreed: "種牡馬",
      damBreed: "ダム品種"
    },
    user: {
      selectLanguage: "言語を選択する",
      unitPreference: "単位の設定",
      selectUnitOfMeasure: "測定単位を選択してください",
      importedUser: "インポートされたユーザー",
      impFileStatus: "インポートファイルのステータス",
      loadingUser: "ユーザーを読み込んでいます...お待ちください",
      totalUsers: "総ユーザー数",
      pendingUsers: "保留中のユーザー",
      changePassword: "パスワードを変更する",
      goodIdeaToUsePassword: "他の場所では使用していない強力なパスワードを使用することをお勧めします。",
      enterCurrentPassword: "現在のパスワードを入力してください",
      enterNewPassword: "新しいパスワードを入力してください",
      reEnterPassword: "新しいパスワードを再入力してください",
      enterPassword: "パスワードを入力する",
      repeatNewPassword: "新しいパスワードを繰り返す",
      emailAddr: "電子メールアドレス",
      enterYourPhoneNumber: "電話番号を入力してください",
      pleaseTypeOldPassword: "古いパスワードを入力してください。",
      pleaseTypeNewPassword: "新しいパスワードを入力してください。",
      pleaseTypeConfirmPassword: "確認用のパスワードを入力してください。",
      passwordChangedSuccesFully: "パスワードは正常に変更されました",
      currentPassword: "現在のパスワード",
      newPassword: "新しいパスワード",
      passwordDoesNotMatch: "パスワードが一致しません。",
      emailCanNotBeEmpty: "メールを空にすることはできません",
      profileUpdated: "プロフィール更新",
      profileNotUpdated: "プロファイルが更新されていません",
      unableToVerifyEmail: "メールを確認できません",
      otpSentOnEmail: "OTP は電子メールで送信されます",
      otpSentSuccessFully: "OTP が正常に送信されました",
      importUsers: "ユーザーのインポート",
      imageUpdated: "画像を更新しました",
      departmentName: "部署名",
      departmentNum: "部門番号",
      departmentAdded: "部門を追加しました",
      departmentNotAdded: "部門が追加されていません",
      searchDepartnment: "部署名または部署名番号で検索",
      addDepartMent: "部門の追加",
      addDepartment: "部門の追加",
      roleNameIsRequired: "ロール名は必須です",
      roleNameMustBeLessThan15Chars: "ロール名は 15 文字未満である必要があります",
      roleAdded: "役割が追加されました",
      editDepartment: "編集部門",
      departmentUpdated: "部門が更新されました",
      departmentNotUpdated: "部門が更新されていません",
      deleteDepartment: "部門の削除",
      deleteDepartmentMessage: "この部門を削除してもよろしいですか。",
      noRoleAvailable: "利用可能な役割がありません",
      roleUpdated: "役割が更新されました",
      roleNotUpdated: "役割が更新されていません",
      editRole: "役割の編集",
      allRole: "すべての役割",
      addNewRole: "新しい役割の追加",
      allDepartment: "全部門",
      permissionsUpdated: "権限が更新されました",
      permissionsnotUpdated: "権限が更新されていません",
      roleNo: "役割番号",
      searchByEmailAndName: "メールアドレスと名前で検索",
      userID: "ユーザーID",
      userUpdated: "ユーザーが更新されました",
      userNotUpdated: "ユーザーが更新されていません",
      userAdded: "ユーザー追加",
      userNotAdded: "ユーザーが追加されていません",
      activateUser: "ユーザーをアクティブ化する",
      deactivateUser: "ユーザーを非アクティブ化する",
      userStatusMsg: "ユーザーステータスを変更してもよろしいですか",
      countryRequired: "国は必須です",
      stateRequired: "状態は必須です",
      cityRequired: "市区町村は必須です",
      searchByRole: "役割番号、役割名、部門で検索",
      noModuleAvailable: "利用可能なモジュールがありません",
      searchBYModuleName: "モジュール名で検索"
    },
    farm: {
      farmID: "ファームID",
      onTheFarm: "農場で",
      userRoles: "ユーザーの役割",
      adduser: "ユーザーを追加する",
      addAuser: "ユーザーを追加する",
      uploadUsers: "ユーザーをアップロードする",
      addNewUser: "新しいユーザーを追加",
      selectDept: "部門を選択してください",
      selectRole: "役割の選択",
      editUser: "ユーザーの編集",
      totalFarms: "トータルファーム",
      NoAnimalsRegisteredForthisFarm: "この農場には動物が登録されていません",
      farmsPerPage: "ページあたりのファーム数",
      regularFarms: "通常の農場",
      farmRegisteredProducts: "農場登録商品",
      searchByFarmNameAndId: "農場名と農場 ID で検索",
      loadingProductsPleaseWait: "製品を読み込み中...お待ちください",
      farmName: "農場名",
      farmLocation: "農場の場所",
      productName: "商品名",
      stockStatus: "在庫状況",
      inStock: "在庫あり",
      searchByProductName: "製品名から探す",
      productCategory: "製品カテゴリ",
      products: "製品",
      farms: "農場",
      registerAfarm: "農場を登録する",
      govtRegistry: "政府",
      cooperativeID: "組合ID",
      farmType: "農場の種類",
      contractMating: "契約交配",
      customization: "カスタマイズ",
      recordsPerpage: "ページあたりのレコード数",
      restoreDefault: "デフォルトを復元",
      apply: "申し込み",
      searchState: "農場ID、政府登録簿、協同組合ID、農場タイプ、契約交配による検索",
      farmOwner: "農場の所有者",
      govRegistrationNo: "政府登録番号",
      farmInformation: "農園情報",
      ownershipType: "所有権の種類",
      communityName: "コミュニティ名",
      farmLicenseInformation: "農場ライセンス情報",
      licenseNumber: "ライセンス番号",
      licenseExpiryDate: "ライセンスの有効期限",
      regulatorName: "レギュレーター名",
      regulatorRepresentativeName: "規制当局の代表者名",
      farmLocationSize: "農場の場所",
      productionSystem: "生産システム",
      country: "国",
      state: "州",
      city: "街",
      street: "街",
      houseNumber: "家屋番号",
      farmRegistration: "農場登録",
      cancel: "キャンセル",
      register: "登録",
      ok: "Ok",
      totalFarmSize: "農場の合計サイズ",
      farmGeographicLocation: "農場の地理的位置",
      perimeterPointLongitude: "外周点の経度",
      perimeterPointLatitude: "外周点の緯度",
      perimeterPointLabel: "周囲点ラベル",
      perimeterLength: "周囲の長さ",
      farmLatitude: "農場の緯度",
      farmLongitude: "農場の経度",
      editFarm: "ファームの編集",
      update: "アップデート",
      editAfarm: "ファームを編集する",
      nextFarm: "ネクストファーム",
      nameoftheFarm: "農園の名前",
      registerAProduct: " 製品を登録する",
      farmProducts: "農産物",
      calf: "ふくらはぎ",
      steer: "ステアリング",
      heifer: "雌牛",
      sire: "種牡馬",
      dam: "ダム",
      registerAnAnimal: "動物を登録する",
      farmAnimals: "家畜",
      farm_type: "農園型",
      farm_Owner: "農場オーナー",
      dateOfRegistration: "登録日",
      dataIsNotAvailableForThisFarm: "このファームのデータは利用できません",
      registerNewProduct: "新しい製品を登録する",
      information: "情報",
      licenseInfo: "ライセンス情報",
      locationInfo: "位置情報",
      geoLocation: "地理的位置",
      perimeterLengthState: "農場の周囲の長さ (フェンスの長さ)",
      totalFarmSizeState: "農場の規模",
      productionSystemState: "農場で使われている生産システム",
      contractMatingState: "農場が参加する契約交配プログラムの規定。",
      ownershipTypeState: "所有権の種類",
      regulatorRepresentativeNameState: "ライセンスを解除した規制当局を代表する人の名前",
      regulatorNameState: "ライセンスを発行した規制当局の名前",
      licenseExpiryDateState: "現在のライセンスの有効期限が切れる日付",
      licenseNumberState: "規制当局によって公開されたライセンス番号",
      plotNumberState: "農場の番地。",
      plotNumber: "家屋/地番",
      streetStatement: "農場の通りの名前。",
      cityStatement: "農場がある都市。",
      stateStatement: "農場がある国の地域。",
      countryState: "農場がある国。",
      perimeterPointLongitudeState: "農場上の 1 点の経度。",
      perimeterPointLatitudeState: "農場上の 1 点の緯度。",
      perimeterPointLabelState: "ポイントのラベル。",
      farmLongitudeState: "農場の経度。",
      farmLatitudeState: "農場の緯度。",
      farmNameH: "農場の名前",
      farmTypeH: "さまざまな活動が行われる農場のタイプ。",
      farmOwnerH: "農場の所有者の名前 (情報を入力すると自動生成される農場名)",
      ownershipTypeH: "自分が耕作する土地を所有/管理する農家とそうでない農家のタイプ。",
      govtRegNumbH: "規制当局によって割り当てられた農場の登録番号",
      contractMatingH: "農場が参加する契約交配プログラムの規定",
      productionSystemH: "農場で使用されている生産システム",
      cooperativeIDH: "農場が加盟している協同組合のID ",
      licenseNumberH: "規制当局によって発行されたライセンス上の、所有者を識別するための識別番号。",
      licenseExpiryDateH: "現在のライセンスの有効期限が切れる日付",
      regularNameH: "ライセンスを発行した規制当局の名前",
      regularRepName: "ライセンスを解除した規制当局を代表する人の名前",
      countryH: "農場がある国。",
      stateH: "農場がある国の地域。",
      cityH: "農場がある都市。",
      streetH: "農場の通りの名前。",
      houseNumberH: "農場の番地。",
      totalFarmSizeH: "農場の規模とは、休閑地を含み、自然植生、樹木、または牧草地の下にある土地を除く、農場によって現在耕作されている土地の合計です。",
      farmLatitudeH: "赤道の北または南の距離の測定値です。",
      farmLongitudeH: "本初子午線の東または西の距離を測定します。",
      perimeterLengthH: "農場の周囲の長さ（フェンスの長さ）",
      perimeterPointLabelH: "ポイントのラベル。 ",
      perimeterPointLatH: "農場上の 1 点の緯度",
      perimeterPointLongH: "農場上の一点の経度",
      noProductAvailable: "利用可能な製品がありません",
      farmUpdated: "ファームが更新されました",
      performance: "パフォーマンス",
      milkInformation: "牛乳に関する情報",
      farmNameRequired: "農場名は必須です"
    },
    login: {
      welcome: "いらっしゃいませ！",
      welInfo: "資格情報を入力します。",
      login: "ログイン",
      forgotPassword: "パスワードをお忘れですか",
      forgotPasswordDesc: "アカウントに関連付けられた電子メール アドレスを入力してください。",
      backToLogin: "ログインに戻る"
    },
    actionListmod: {
      actionList: "アクションリスト",
      tODAY: "今日",
      createTask: "タスクの作成",
      myActivities: "私の活動",
      jhonSmith: "ジョン・スミス",
      farmID: "ファームID",
      dateOfEvent: "イベントの日付",
      actionRequired: "必要なアクション",
      actionTaken: "講じられたアクション",
      animalEventID: "動物イベントID",
      cANCEL: "キャンセル",
      cONFIRM: "確認",
      sTATEMENT: "このレコードを削除してもよろしいですか?",
      dAY: "日",
      wEEK: "週",
      mONTH: "月",
      sUBMIT: "送信",
      startDate: "開始日",
      endDate: "終了日",
      rEPEAT: "繰り返す",
      taskCategory: "タスクのカテゴリ",
      pRIORITY: "優先順位",
      aSSIGNEE: "譲受人",
      selectLocation: "場所を選択してください",
      selectAnimals: "1 匹以上の動物を選択してください",
      dESCRIPTION: "説明",
      customRecurrence: "カスタムの繰り返し",
      repeatEvery: "毎回繰り返す",
      taskName: "タスク名",
      enterDescription: "説明を入力してください",
      toDo: "やるべきこと",
      assignTo: "に割り当てます",
      status: "スターテス",
      nOTE: "ノート",
      noTaskAvailable: "利用可能なタスクはありません",
      healthRecord: "健康記録",
      iD: "ID",
      tAG: "鬼ごっこ",
      dateOfbirth: "生年月日",
      taskTakenat: "タスクの実行日時",
      gENDER: "性別",
      bREED: "繁殖",
      regDate: "登録",
      updateHealthRecord: "動物の健康記録を更新する",
      treatment: "処理",
      reasonOftreatment: "治療の理由",
      treatmentDate: "治療日",
      dIAGNOSIS: "診断",
      drugId: "薬剤ID",
      drugName: "薬剤名",
      drugWithdrawalperiod: "休薬期間",
      attendingVeterinarian: "担当獣医師",
      packId: "パックID",
      noItemsselected: "項目が選択されていません",
      healthRecordsubmission: "健康記録の提出",
      inseminationRecordsubmission: "授精記録の提出",
      inseminatorName: "授精者名",
      inseminatorId: "授精者ID",
      conceptionRate: "受胎率",
      dateOfmeasurement: "測定日",
      recordSubmission: "記録の提出",
      uPDATE: "アップデート",
      updateTask: "更新タスク"
    },
    inseminatorStatisticsInfo: {
      addInseminatorInfo: "授精者情報の追加",
      inseminatorNumber: "授精者番号",
      loadingInseminatorPleaseWait: "授精装置を読み込み中...お待ちください",
      searchByIDAndName: "IDと名前で検索",
      inseminatorInfoAdded: "授精者情報を追加しました",
      inseminatorInfoNotAdded: "授精者情報が追加されていません",
      inseminatorInfoUpdated: "授精者情報を更新しました",
      inseminatorInfoNotUpdated: "授精者情報が更新されていません",
      editAInseminatorInfo: "授精者情報の編集",
      inseminatorList: "授精者リスト",
      inseminatorInfoDetails: "授精者情報の詳細",
      updateInseminatorInfo: "授精者情報を更新"
    },
    organizationNtrInfo: {
      loadingOrdersPleaseWait: "注文を読み込んでいます...お待ちください",
      addStocks: "在庫を追加する",
      addStock: "在庫を追加する",
      quantity: "量",
      selectUnit: "ユニットの選択",
      farmProducts: "農産物",
      cost: "料金",
      transactionID: "トランザクションID",
      recipientID: "受信者ID",
      orderID: "注文ID",
      recepientName: "受取人名",
      createAOrder: "注文を作成する",
      totalStocks: "総在庫数",
      orders: "注文",
      totalPending: "合計保留中",
      totalDelivered: "合計納品数",
      searchByRecepientNameOrderIdRecepientId: "受信者名、注文 ID、受信者 ID で検索",
      chooseTheDate: "日付を選択してください",
      transactionDate: "取引日",
      selectCategory: "カテゴリを選んでください",
      volumeOfProduct: "製品の量",
      productQuantity: "製品数量",
      productRecipientId: "製品受信者ID",
      productRecipientName: "製品の受取人名",
      productRecipientType: "製品の受取人の種類",
      singleProduct: "単品",
      orderPlaced: "注文済み",
      orderNotPlaced: "注文は行われていません",
      totalPrice: "合計金額",
      currency: "通貨",
      selectCurrency: "通貨の選択",
      address: "住所",
      enterAddress: "住所を入力してください",
      attachments: "添付ファイル",
      chooseFile: "ファイルを選ぶ",
      nameOfTheFarm: "農園の名前",
      loremIpsumHasBeenTheIndustrySStandardDummyText: "Lorem Ipsum は、1500 年代に未知の印刷業者が印刷物を印刷して以来、業界の標準的なダミー テキストです。",
      billedTo: "に請求",
      orderStatus: "注文の状況",
      selectStatus: "ステータスの選択",
      cadbury: "キャドベリー",
      totalAmount: "合計金額",
      deliveryCharges: "配送料",
      orderDetails: "注文詳細",
      deliveryOnTime: "時間どおりに配達",
      productID: "製品番号",
      productRegistration: "製品登録",
      enterTheNameOfTheProduct: "製品名を入力してください",
      nameOfTheProduct: "製品名",
      productAdded: "製品を追加しました",
      productNotAdded: "製品が追加されていません"
    },
    drug: {
      dRUGS: "薬物",
      registerAdrug: "医薬品を登録する",
      sEARCH: "検索",
      genericName: "一般名",
      manufacturer: "メーカー",
      distributor: "卸売業者",
      registrationDate: "登録日",
      drugRegistration: "医薬品登録",
      drugInformation: "医薬品情報",
      packExpiration: "パックの有効期限",
      drugId: "薬剤ID",
      drugName: "薬剤名",
      drugGenericname: "医薬品の一般名",
      drugManufacturer: "製薬会社",
      distributorName: "販売代理店名",
      drugRegistrationdate: "医薬品登録日",
      nextDrug: "次の薬",
      editDrug: "薬物の編集",
      updateDrug: "薬剤を更新する",
      deleteDrug: "薬物の削除",
      noRecordfound: "レコードが見つかりませんでした",
      addDrug: "薬剤を追加する",
      statementDrug: "薬は削除されました。 ",
      cANCEL: "キャンセル",
      cONFIRM: "確認",
      sTATEMENT: "このレコードを削除してもよろしいですか?",
      ok: " Ok",
      information: "情報",
      packOrder: "パックオーダー",
      packPrescription: "パックの処方箋",
      packReservation: "パック予約",
      packLocation: "パックの場所",
      drugDozedam: "ダムの1日の薬剤投与量",
      drugDozecalf: "子牛の1日の薬剤投与量",
      drugFormate: "薬剤フォーマット",
      drugDistributor: "医薬品販売業者",
      drugActiveingridents: "医薬品有効成分",
      drugSubstitutionId: "薬剤代替ID",
      packId: "パックID",
      packBatchNumber: "パックバッチ番号",
      drugIdStatement: "薬剤のバッチ番号。",
      drugNameSatement: "医薬品が販売される際に宣伝されているブランド名。",
      drugGenericnameStatement: "医薬品が販売される際に宣伝されているブランド名ではなく、医薬品の化学組成。",
      drugFormateSatement: "薬剤のバッチ番号。",
      drugDozecalfSatement: "子牛への薬物投与量を知るため。",
      drugDozedamStatement: "ダムへの薬物投与量を知るため。",
      drugManufacturerStatement: "製薬メーカーの詳細。",
      drugDistributorStatement: "医薬品販売業者の詳細。",
      drugRegistrationdateStatement: "特定の国での医薬品登録日。",
      drugActiveingridentsStatement: "有効成分のリスト。",
      drugSubstitutionIdStatement: "主な薬剤が現在入手できない場合に、その薬剤の代替となる可能性のある薬剤の ID。",
      packIdStatement: "パックのバーコードまたは RF ID。",
      packBatchNumberStatement: "メーカーによってパックに割り当てられたバッチ番号。",
      locationWarehouseID: "場所の倉庫ID",
      locationWarehouseIDState: "パックが保管されている倉庫の ID。",
      locationRackID: "ロケーションラックID",
      locationRackIDStatement: "パックが保管されているラックの ID。",
      locationTierID: "ロケーション階層ID",
      locationTierIDStatement: "パックが保管されているラック上の層の ID。",
      locationPositionID: "位置位置ID",
      locationPositionIDStatement: "パックが保管されている層上の位置の ID。",
      storageTemperatureCondition: "保存温度条件",
      storageTemperatureConditionStats: "パックの保管状態。",
      containerForm: "コンテナフォーム",
      containerFormStatement: "薬剤が詰められた容器の形状。",
      consistQuantity: "数量を構成する",
      consistQuantityStatement: "パック内の錠剤、ボトルなどの量。",
      releaseId: "リリースID",
      releaseIdStatement: "農家がパックを受け取った後に割り当てられるID。",
      releaseDate: "発売日",
      releaseDateStatement: "農家がパックを在庫から取り出した日付。",
      packManufacturedDate: "パックの製造日",
      packManufacturedDateStatement: "パックが製造された日付。",
      packImportedDate: "パックの輸入日",
      packImportedDateStatement: "パックがインポートされた日付。",
      packExpirationDate: "パックの有効期限",
      packExpirationDateStatement: "パックの有効期限が切れる日付。",
      expiredSoonFlag: "もうすぐ期限切れフラグ",
      expiredSoonFlagState: "パックの有効期限がもうすぐ切れるという警告。",
      packTotalVolumeLeft: "パック残量合計",
      packTotalVolumeLeftState: "在庫に残っている同じ成分のパックの合計数。",
      packOrderID: "パック注文ID",
      packOrderIDState: "販売代理店にパックを注文した後に割り当てられる ID。",
      packQuantityOrdered: "注文したパックの数量",
      packQuantityOrderedState: "販売代理店から注文されたパックの数。",
      packPrice: "パック料金",
      packPriceStatement: "パックの価格。",
      priceCurrency: "価格通貨",
      packPricecurrency: "パック価格の通貨",
      packPricecurrencyState: "価格が指定される通貨名。",
      packPaydate: "パックの支払い日",
      payDate: "支払日",
      packPaydateState: "支払いがディストリビューターにリリースされた日付。",
      packShippingID: "パック配送ID",
      shippingID: "配送ID",
      packShippingIdState: "ディストリビュータからパックが到着したときのパックの配送 ID。",
      packShippingDate: "パックの発送日",
      shippingDate: "発送日",
      packShippingDateState: "パックが在庫に到着した日付。",
      packOrderStatus: "パック注文ステータス",
      packOrderStatusState: "現在の注文のステータス。",
      recepientKeeperId: "受信者キーパーID",
      recepientKeeperIdStatement: "パックを受け取った個人/組織の名前。",
      recepientFarmId: "受信側ファームID",
      recepientFarmIdStatement: "動物用医薬品の受領者が所属する農場のID。",
      recepientAnimalId: "受信動物ID",
      recepientAnimalIdState: "薬（パック）が処方された動物のID。",
      specialistComments: "専門家のコメント",
      specialistCommentsState: "処方に関する専門家/獣医師のコメント。",
      specialistName: "専門家名",
      specialistNameState: "薬を処方した専門医/獣医師の名前。",
      specialistID: "スペシャリストID",
      specialistIDState: "薬を処方した専門医/獣医師のID。",
      reservedByKeeperId: "Keeper ID によって予約済み",
      reservedByKeeperIdState: "パックを予約したキーパー ID。",
      reservedByFarmId: "ファーム ID によって予約済み",
      reservedByFarmIdState: "パックを予約したファーム ID。",
      reservationTimeoutDate: "予約タイムアウト日",
      reservationTimeoutDateState: "パックを購入されなかった場合、予約が自動的にキャンセルされる日付。",
      reservationTimeout: "予約タイムアウト",
      reservationTimeoutState: "パックを購入または使用しなかった場合に予約が自動的にキャンセルされるまでの時間数",
      reservationDate: "予約日",
      reservationDateState: "パックの予約日。",
      reservationStatus: "予約状況",
      reservationStatusState: "パック予約のステータス。",
      loadingDrugsPleaseWait: "薬剤をロード中...お待ちください",
      quantityOrder: "数量注文",
      keeperID: "キーパーID",
      timeoutDate: "タイムアウト日",
      warehouseID: "倉庫ID",
      rackID: "ラックID",
      tierID: "階層ID",
      positionID: "ポジションID",
      temperatureCondition: "温度条件",
      manufactureDate: "製造年月日",
      importedDate: "輸入日",
      totalVolumeLeft: "残りの総量"
    },
    reports: {
      myReports: "私のレポート",
      satelliteReports: "衛星レポート",
      weatherReports: "天気予報",
      pregnancyAnalytics: "妊娠分析",
      semenEmbroyAnalytics: "精液/胚芽分析",
      semenAnalytics: "精液分析",
      embryoAnalytics: "胚分析",
      calfAnalytics: "ふくらはぎの分析",
      milkProduction: "牛乳の生産",
      totalMilkType: "総乳種類",
      totalAnimalAnalytics: "トータルアニマルアナリティクス",
      animalAnalytics: "動物分析",
      analyticsAndReporting: "分析とレポート作成",
      filterByCountry: "国でフィルターする",
      filterByFarm: "農場でフィルターする",
      filterByRegion: "地域によるフィルター",
      filterByMonth: "月によるフィルター",
      filterByDate: "日付によるフィルター",
      filterByRole: "役割によるフィルター",
      filterByYear: "年でフィルタリングする",
      filterByTrait: "特性によるフィルター",
      avgBreedingValue: "平均育種価",
      avgEconomicIndex: "平均経済指数",
      breederReport: "ブリーダーレポート",
      semenTransferDate: "精液移植日",
      semenEmbryoProductionReport: "精液・胚生産報告書",
      semenProducts: "精液製品",
      meatProducts: "肉製品",
      totalProducts: "総製品数",
      semenEmbryoReport: "精液・胚レポート",
      numOfStraws: "ストローの数",
      collectionDate: "収集日",
      productionReport: "制作報告書",
      receipientId: "受信者ID",
      embryoId: "胚ID",
      semenStrawId: "精液ストローID",
      dataScientist: "データサイエンティスト",
      dataScientistReport: "データサイエンティストレポート",
      productReport: "製品レポート",
      dairyProducts: "乳製品"
    },
    genoPerformance: {
      performanceOfGenoType: "GenoTypeのパフォーマンス",
      addAGenoType: "GenoType を追加する",
      breedName: "犬種名",
      chromosome: "染色体",
      sequenceChange: "シーケンスチェンジ",
      inheritance: "継承",
      diseaseName: "病名",
      referenceSequence: "参照配列",
      pubmedReference: "Pubmed リファレンス",
      genoTypeRegistration: "ジェノタイプの登録",
      breed: "繁殖",
      editAGenoType: "GenoType を編集する",
      editGenoType: "GenoType の編集",
      loadingGene: "Geno を読み込み中...お待ちください",
      geneTypeList: "遺伝子型リスト"
    },
    reportings: {
      conception: "コンセプション（データサイエンティスト）",
      performanceOfGenoData: "遺伝子型のパフォーマンス(データサイエンティスト)",
      totalInsemination: "完全授精",
      embryo: "胚",
      animalVaccinationRecord: "動物の予防接種記録",
      dataNotAvailable: "このファームのデータは利用できません。",
      pregnancyStatus: "妊娠の状況",
      healthReport: "健康レポート",
      heavyMilk: "濃厚ミルク",
      standardMilk: "スタンダードミルク"
    },
    sidebar: {
      healthAnalytics: "健康分析",
      productionAnalytics: "生産分析"
    },
    epd: {
      regNo: "動物登録番号は、マーキング手段を使用して動物に与えられる固有のコードであり、特定の動物を識別して追跡するためのプロセスが確実に行われるようにします。",
      internationalID: "動物の国際ID",
      location: "動物が生まれた国・地域 ",
      animalName: "動物の標準名/命名法",
      gender: "動物の性別（オス/メス）",
      additionalIDMethod: "動物を識別するためにどのような方法が使用されましたか (例: 耳タグ、タトゥー)",
      damID: "動物の母動物のIDまたは登録番号 - 動物の雌親/実母の番号のID",
      sireId: "動物、特に繁殖のために飼われている雄牛または人工授精に使用される雄牛の精液の雄親の ID または登録番号。",
      dateOfBirth: "動物の生年月日。",
      breederHerdCode: "ブリーダー ハード コードは主にブリーダー協会によって提供されます",
      seasonofBirth: "月ごとに記した動物の誕生の季節",
      birthYear: "動物が生まれた年",
      birthManagementCode: "出産管理コードは主にユーザー/農家によって提供されます",
      birthSex: "動物の性別（オス/メス）",
      birthWeight: "子牛の出生体重 ",
      primaryBreed: "動物の主な遺伝的寄与率 ",
      secondaryBreed: "マイナー % 動物の遺伝的寄与 ",
      breedComposition: "品種構成パーセンテージとは、個々の動物または動物のグループの遺伝子構成内のさまざまな品種の比例表現を指します。",
      conceptionMethod: "動物がどのように妊娠したか（自然交配/授精/胚移植）。",
      accuracyWeight: "精度の重み",
      damAge: "ダムの築年数（月/年）。 ",
      weaningWeight: "離乳時 離乳時の動物の体重。",
      weaningDate: "動物が離乳した日",
      weaningSex: "離乳した動物の性別。",
      managementPastureCode: "ユーザー/農家によって管理/牧草地に与えられたコード ",
      creep: "クリープフィーディングは、授乳中の子牛に補助飼料（穀物または飼料）を与えることです。",
      weaningContemporaryGroupCode: "離乳体重の規定 現代グループ",
      birthContemporaryCode: "現代のコードの誕生",
      yearlingDate: "動物の生後 1 年または生後 2 年の日付",
      managementFeedUnitCode: "ユーザーが管理・フィード装置に付与したコード",
      yearlingSex: "1歳時の動物の性別 ",
      yearlingWeight: "当歳体重は、離乳後の直接的な成長の測定値であり、子牛のポンド単位で測定され、肥育場で市場に流通する子孫の潜在的な成績を反映するためによく使用されます。",
      yearlingHeight: "1歳時の動物の身長 ",
      yearlingWeightContemporaryGroupCode: "当歳馬体重規定 現代グループ",
      weaningYearlingWeightContemporaryGroupCode: "離乳期または当歳馬の体重コード Contemporary Group",
      daysOnFeed: "特定の飼料を与えられた日数 例: 低コストで市場性の高い牛肉を生産するために、成長期の若い牛には高エネルギーの飼料が与えられます。",
      managementFeedUnitPenCode: "ユーザーが管理/フィードユニット/ペンに与えたコード",
      harvestDate: "肉のために屠殺された（殺された）動物の日付",
      gradingDate: "死骸の日付は特定の基準に従って格付けされました",
      carcassSex: "死骸の性別",
      dateonFeed: "動物が新しい飼料に切り替えられた日 例: 成長期の若い牛には、低コストで市場性のある牛肉を生産するために高エネルギーの飼料が与えられます。",
      KPH: "% KPH は、屠体の体腔、特に腎臓、骨盤、心臓の領域に見られる総脂肪の割合です。",
      carcassWeight: "枝肉の重量は、皮、頭、胃腸管、内臓を収穫し除去した後の熱いまたは冷やしていない重量です。",
      fatThickness: "脂肪の厚さは小さな定規を使用してインチ単位で測定されます。",
      marbling: "霜降りは、筋肉内および筋線維束の間に蓄積する、目に見える不飽和（健康な）筋肉内脂肪です。",
      ribeyeArea: "グリッド (例: 8、9、または 10 インチ) を使用して、12 番目と 13 番目の肋骨の間で測定されたリブアイ (ロースまたはリブアイ筋最長背筋) の面積 (平方インチ)。",
      animalStatus: "農場の動物の状態: 健康、病気など"
    },
    manageAnimalGroupings: {
      resetModeTooltip: "\n        リセットモード <br>\n            このモードでは <br>\n            1) 対象となるすべての特性について、すべての現代グループ (CG) の特性を設定/定義します。 <br>\n            2) すべての動物を対応する CG に割り当てます。 <br>\n            3) 動物の割り当てが満足できない場合は、CG を調整/変更し、再度動物を新しい対応する CG に割り当てます。 <br>\n            4) 必要に応じて、CG および対応する動物のグループ化/割り当てに満足するまで、上記の手順を繰り返します。<br>\n        ",
      maintainanceModeHeadingTooltip: "リセット (モード) が完了すると、メンテナンス モードに入り、リセットで計算された EDP が次のリセット (2 ～ 6 か月後になる可能性があります) まで各動物で一定に保たれます。",
      maintainanceModeTooltip: "RESET MODE が完了したら、RESET FINALIZED ボタンを押してシステムがすべての動物の EPD を計算できるようにし、RESET モードを終了し、MAINTENANCE モードを開始します。",
      resetToggleTooltip: "EPD モデル設定で [リセット トグル] を有効にして、動物を CG に割り当てます。"
    },
    geneticsAndBreeding: {
      geneticsAndBreeding: "遺伝学",
      geneticSearchTool: "遺伝子検索ツール",
      dataSubmission: "データ提出・動物選定",
      animalsWithExpectedProgenyDifferences: "子孫予測差 (EPD) の計算のための動物の選択",
      searchByAnimalIdName: "動物のID、名前で検索",
      rowsPerPage: "ページあたりの行数",
      individualEntry: "個人エントリー",
      bulkEntry: "一括入力",
      registerANewAnimalOrSelectAnExistingAnimal: "新しい動物を登録するか、既存の動物を選択します。",
      registerNewAnimal: "新しい動物を登録する",
      selectExistingAnimal: "既存の動物を選択",
      animalID: "動物ID",
      animalName: "動物の名前",
      tag: "鬼ごっこ",
      dateOfBirth: "生年月日",
      gender: "性別",
      birthDate: "生年月日",
      birthWeightLb: "出生体重 (ポンド)",
      birthWeightKg: "出生体重(kg)",
      weaningWeightLb: "離乳時の体重 (ポンド)",
      weaningWeightKg: "離乳体重(kg)",
      yearlingWeightLb: "当歳体重 (ポンド)",
      yearlingWeightKg: "当歳体重(kg)",
      carcassWeightLb: "枝肉重量 (ポンド)",
      carcassWeightKg: "枝肉重量(kg)",
      animalSelection: "動物の選択",
      animalSearchTool: "動物検索ツール",
      back: "戻る",
      searchByEPDs: "EPDで検索",
      searchByIds: "IDで検索",
      selectBreed: "品種を選択してください",
      selectGender: "性別を選択して下さい",
      selectRequiredBreedForCattle: "牛に必要な品種を選択してください",
      resetFilter: "フィルターをリセットする",
      birthWeightHeader: "出生体重(BW): ",
      birthWeightDef: "出生時の子牛の体重の違いを比較し、ポンドまたはキログラムで測定します。",
      weaningWeightHeader: "離乳体重(WW): ",
      weaningWeightDef: "WW EPD は、ポンドまたは kg で測定される離乳前の成長の推定値です。",
      yearlingWeightHeader: "当歳体重(YW): ",
      yearlingWeightDef: "YW EPD は、ポンドまたは kg で測定される離乳後の成長の推定値です。",
      ribEyeAreaHeader: "リブアイエリア(REA): ",
      ribEyeAreaDef: "REA は、リブロースを形成する筋肉のサイズを平方インチで測定します。REA EPD は、収穫された牛の枝肉測定に基づいて調整された 365 日のリブロース面積測定値の差異を反映します。",
      marblingHeader: "マーブリング(MARB): ",
      marblingDef: "MARB EPD は、リブアイ内の筋肉内脂肪のパーセンテージの単位です。MARB EPD は、収穫された牛の枝肉測定に基づいて調整された 365 日の霜降りスコア (筋肉内脂肪、[IMF]) の差異を反映します。",
      fatThicknessHeader: "脂肪の厚さ(FAT): ",
      fatThicknessDef: "背脂肪のインチ (100 分の 1 インチ) は、FT の測定単位です。",
      carcassWeightHeader: "枝肉重量(CW): ",
      carcassWeightDef: "枝肉重量は、最終製品価値に対するポンドの影響を考慮する場合に有益な特性です。",
      yieldGradeHeader: "歩留まり等級(YG): ",
      yieldGradeDef: "USDA 歩留まり等級スコアリング システムは、YG EPD の測定単位です。",
      milkHeader: "ミルク(MK): ",
      milkDef: "MK EPD は、母親の搾乳能力に応じて、子牛の離乳時の体重をポンド単位で測定します。",
      totalMaternalHeader: "トータル・マターナリング(TM): ",
      totalMaternalDef: "TM は、乳量と牛の成長に関する遺伝学の両方による子牛の離乳体重への影響を測定します。",
      calvingEaseDirectHeader: "分娩イーズダイレクト(CED): ",
      calvingEaseDirectDef: "CED EPD は、補助なしの分娩の割合としてリストされます。",
      calvingEaseMaternalHeader: "出産容易母性(CEM): ",
      calvingEaseMaternalDef: "雄牛の娘が 2 歳のときに補助なしで出産する能力を測定します。",
      stayabilityHeader: "滞在性(STAY): ",
      stayabilityDef: "ST EPD は、雄牛が「そこに留まる」牛を産む能力を予測します。 ",
      docilityHeader: "従順さ(DOC): ",
      docilityDef: "DOCは牛の気質を測定します。",
      max: "マックス",
      min: "最小",
      accuracy: "正確さ",
      sortBy: "並び替え",
      traits: "灰色で表示されている特性は開発中であり、2023 年第 2 四半期にリリースされる予定です。",
      searchResults: "の検索結果",
      recordsFound: "記録が見つかりました",
      compareSelected: "選択したものを比較",
      animalIdentification: "動物の識別",
      errorMessage: {
        birthWeight: "出生体重の最大値は出生体重の最小値より小さくすることはできません",
        weaningWeight: "離乳時の体重の最大値は、離乳時の体重の最小値より小さくすることはできません",
        yearlingWeight: "当歳馬体重の最大値は、一歳馬体重最小値より小さくすることはできません",
        carcassWeight: "枝肉重量の最大値は出生体重の最小値より小さくすることはできません",
        fatThickness: "脂肪の厚さの最大値は離乳時の体重の最小値より小さくすることはできません",
        marbling: "霜降りの最大値は当歳馬体重の最小値を下回ることはできません",
        ribeyeArea: "リブアイ面積の最大値は出生体重の最小値より小さくすることはできません",
        yieldGrade: "収量等級の最大値は離乳時体重の最小値より小さくすることはできません",
        milk: "ミルクの最大値は離乳時の体重の最小値より小さくすることはできません"
      },
      reg: "登録",
      name: "名前",
      sex: "セックス",
      tattoo: "入れ墨",
      dob: "生年月日",
      EPD: "EPD",
      rank: "ランク",
      searchValue: "検索値",
      typeHere: "ここに入力",
      searching: "検索中...",
      fetchingResult: "結果を取得しています...お待ちください",
      animalsMatchedYourCriteria: "動物があなたの基準に一致しました",
      manageAnimalsGrouping: "動物のグループ化を管理する",
      manageAnimalGroupings: "動物のグループを管理する",
      assignAnimalToContemporaryGroups: "動物を現代のグループに割り当てる",
      resetMode: "リセットモード",
      enterResetMode: "リセットモードに入る",
      maintainanceMode: "メンテナンスモード",
      assigningAnimals: "動物の割り当て",
      excludedAnimals: "除外される動物",
      ungroupedAnimals: "グループ化されていない動物",
      assignAnimalsToCGS: "動物を CGS に割り当てる",
      reset: "リセット",
      excludeAnimals: "動物を除外する",
      resetToMaintainanceMode: "リセット完了 - メンテナンスモードに変更",
      contemporaryGroupsSettings: "現代グループ(CG)設定",
      selectTrait: "特性の選択",
      selectTraitDescription: "特性の選択とは、特定の特性を選択するプロセスを指します",
      traitsType: {
        birthWeight: "出生体重",
        weaningWeight: "離乳時の体重",
        yearlingWeight: "当歳体重",
        carcassWeight: "枝肉重量"
      },
      addNewGroup: "新しいグループを追加",
      contemporaryGroup: "コンテンポラリーグループ",
      contemporaryGroups: "現代グループ",
      editGroup: "グループの編集",
      birthCGCode: "誕生(CG)コード",
      groupName: "グループ名",
      birthSex: "出生時の性別",
      conceptionMethod: "構想方法",
      weaningCGCode: "ウィーニング(CG)コード",
      yearlingCGCode: "イヤーリング(CG)コード",
      dateWeight: "日付の重み",
      weaningyearlingCGcode: "離乳・当歳(CG)コード",
      carcassCGCode: "枝肉(CG)コード",
      breedOfDom: "ダムの品種",
      addNewContemporaryGroup: "新しい現代グループを追加",
      createNewGroup: "新しいグループの作成",
      selectFromDifferentTraits: "さまざまな特性から選択する",
      contemporaryGroupName: "現代のグループ名",
      enterNameHere: "ここに名前を入力してください",
      groupNameIsRequired: "グループ名は必​​須です",
      birthYearRange: "誕生年の範囲",
      theYearAnimalWasBorn: "動物が生まれた年",
      birthYearIsRequired: "誕生年は必須です",
      genderOfNewBornAnimal: "生まれたばかりの動物の性別",
      selectSex: "性別を選択してください",
      theweightOfAnimalAtBirth: "動物の出生時の体重",
      maximumKg: "最大",
      minimumKg: "最小",
      aSeasonisAPeriodOfYear: "季節とは、特別な気候条件によって区別される一年の期間です。",
      seasonofBirthIsRequired: "誕生季節は必須です",
      majorGenericContributionOfAnimal: "動物の主要な一般的寄与率",
      primaryBreedCompostionIsRequired: "一次品種組成物が必要です",
      secondaryBreedCompostionIsRequired: "二次品種組成物が必要です",
      howTheAnimalWasConceived: "動物がどのようにして生まれたか（自然交配/授精/胚移植）",
      conceptionMethodIsRequired: "構想方法が必要です",
      epdModelSettings: "EPDモデルの設定",
      forResetMode: "リセットモードの場合",
      progenyWeightingFactor: "子孫加重係数",
      weightGivenToTheProgenyFactor: "リセット モードでの EPD 計算の CG 因子に対する子孫因子に与えられる重み。 ",
      enterNumber: "番号を入力してください",
      enterBreed: "品種を入力してください",
      valueShouldBeBetween0and1: "値は 0 から 1 の間である必要があります",
      resetDuration: "リセット期間",
      timeIntervalBetweenLastAndFirstResetMode: "前回のリセット モードと新しいリセット モードの間の時間間隔。この期間の終了時に新しいリセット モードが有効になり、新しい CG と EPD が計算されます。",
      enterNumberOfDays: "日数を入力してください",
      valueCannotBeNegative: "値を負にすることはできません。",
      criticalProgenyPopulation: "重要な子孫集団",
      minimumNumberOfProgenyRecords: "50% 以上の子孫精度 (APD1) (血統精度の場合) を達成するために必要な、システム内の個々の動物の子孫記録の最小数",
      criticalAncestorPopulation: "重要な祖先の集団",
      minimumNumberOfAncestorsRecords: "50% 以上の祖先精度 (APD4) (血統精度の場合) を達成するために必要な、システム内の個々の動物の祖先記録の最小数",
      forBirthWeightCG: "出生体重CG用",
      criticalPopulationInAnimalsContemporaryGroup: "現代の動物グループにおける重要な集団",
      minimumAverageNumberOfAnimalsPerBirthWeight: "50% を超える平均 CG 精度 (ACG3) を達成するために必要な、出生体重 CG あたりの最小平均動物数",
      criticalAveragePopulationPerContemporaryGroup: "現代グループごとの重要な平均人口",
      minimumNumberOfAnimalsInBirthWeight: "50% 以上の CG 精度 (ACG2) を達成するために必要な動物の出生体重 CG 内の動物の最小数",
      forWeaningWeightCG: "離乳体重CG用",
      minimumAverageNumberOfAnimalsPerWeaningWeight: "50% を超える平均 CG 精度 (ACG3) を達成するために必要な離乳体重 CG あたりの最小平均動物数",
      minimumNumberOfAnimalsInWeaningWeight: "50% 以上の CG 精度 (ACG2) を達成するために必要な動物の離乳体重 CG 内の動物の最小数",
      forYearlingWeightCG: "当歳馬体重CG用",
      minimumAverageNumberOfAnimalsPerYearling: "50% を超える平均 CG 精度 (ACG3) を達成するために必要な、当歳馬 CG あたりの最小平均動物数",
      minimumNumberOfAnimalsInYearlingWeight: "50% 以上の CG 精度 (ACG2) を達成するために必要な、動物の当歳体重 CG 内の動物の最小数",
      forCarcassCG: "枝肉CG用",
      minimumAverageNumberOfAnimalsPerCarcassWeight: "50% を超える平均 CG 精度 (ACG3) を達成するために必要な屠体重量 CG あたりの動物の最小平均数",
      minimumNumberOFAnimalInCarcassWeight: "50% 以上の CG 精度 (ACG2) を達成するために必要な動物の屠体重量 CG 内の動物の最小数",
      epdRequiredFieldSettings: "EPD 必須フィールドの設定",
      pleaseSelectRequiredFieldsForCompleteEPD: "完全な EPD 計算のために必要なフィールドを選択してください",
      byDefault: "デフォルトで",
      pleaseNoteThatUsersNotAbleToObtainFullEPD: "注: 必須としてマークしたデータ フィールドをユーザーが提供しない場合、ユーザーは完全な EPD 計算を取得できないことに注意してください。",
      pleaseNoteThatRequiredFieldParametersCannotBeChanged: "注: 以前のパラメータに対する最新のグループがすでに存在するため、必須フィールドのパラメータは変更できないことに注意してください。",
      noResultFound: "結果が見つかりません",
      next: "次",
      cancel: "キャンセル",
      selectAnimal: "動物を選択してください",
      searchBy: "で検索",
      breed: "繁殖",
      regDate: "登録",
      status: "スターテス",
      animalDetails: "動物の詳細",
      add: "追加",
      update: "アップデート",
      dataForEPDs: " EPD のデータ",
      basicInformation: "基本情報",
      birthWeightInformation: "出生体重に関する情報",
      weaningWeightInformation: "離乳時の体重に関する情報",
      yearlingWeightInformation: "当歳馬の体重情報",
      carcassWeightInformation: "枝肉重量情報",
      delete: "消去",
      deleteEpdData: "EPDデータの削除",
      areYouSureYouWantToDeleteEpdData: "EPD データを削除してもよろしいですか。",
      internationalID: "国際ID",
      enterID: "IDを入力してください",
      animalRegistration: "動物登録",
      location: "位置",
      additionalIDMethod: "追加のID方法",
      damID: "ダムID",
      sireID: "種牡馬ID",
      breederHerdCode: "ブリーダーの群れコード",
      birthYear: "生年",
      primaryBreed: "主な品種",
      breedComposition: "品種構成",
      secondaryBreed: "二次品種",
      seasonofBirth: "誕生の季節",
      birthManagementCode: "出生管理コード",
      damAge: "ダメージ",
      years: "年",
      birthContemporaryCode: "現代のコードの誕生",
      accuracyWeight: "精度の重み",
      note: "ノート",
      minimumRequiredFieldForBirthWeight: "出生体重 EPD に最低限必要なフィールド",
      birthYearGenderConceptionMethodBirthWeight: "生まれ年、性別、受胎方法、出生体重",
      weaningWeight: "離乳時の体重",
      weaningDate: "離乳日",
      weaningContemporaryGroupCode: "現代のグループ規範の脱却",
      creep: "忍び寄る",
      managementPastureCode: "管理・牧草コード",
      weaningSex: "離乳セックス",
      minimumRequiredFieldForWeaningWeight: "離乳体重 EPD に最低限必要なフィールド",
      weaningWeightManagementPastureCodeWeaningSexDateWeighed: "離乳時の体重 、 管理・牧草コード 、 離乳時の性別 、 計量日",
      yearlingWeight: "当歳体重",
      yearlingHeight: "当歳の身長",
      yearlingDate: "イヤーリングデート",
      yearlingContemporaryGroupCode: "当歳の現代グループコード",
      managementFeedingCode: "管理/供給コード",
      yearlingSex: "イヤーリングセックス",
      youWillNeedToFillOutFor: "EPD データを取得するには、すべてのフィールドに入力する必要があります。",
      pleaseSelectHavestDateFirstToEnterInfo: "最初に「収穫日」を選択して、リブアイ面積、脂肪の厚さ、霜降りの情報を入力してください。",
      harvestDate: "収穫日",
      dateOnFeed: "フィードの日付",
      daysOnFeed: "フィードの日数",
      gradingDate: "採点日",
      carcassSex: "死骸のセックス",
      carcassWeight: "枝肉重量",
      carcassContemporary: "カーカス コンテンポラリー",
      damBreed: "ダム品種",
      ribEyeArea: "リブアイエリア",
      ribEyeAreaContemporary: "リブアイエリア コンテンポラリー",
      fatThickness: "脂肪の厚さ",
      fatThicknessContemporary: "脂肪の厚さ 現代的",
      marbling: "霜降り",
      marblingContemporary: "マーブリングコンテンポラリー",
      yieldGradeContemporary: "歩留まり等級 現代的",
      animalsNotListedInContemporaryGroupsMsg: "情報が不足しているため、動物は現在のグループに追加されていません。",
      listOfUngroupedAnimals: "グループ化されていない動物のリスト",
      submittingData: "データの送信",
      resendToUser: "ユーザーに再送信",
      submittingAnimalsInGroupMsg: "動物をグループに分類します。",
      pressingResetBtnMsg: "「リセット」ボタンを押すと、動物を現在のグループに再割り当てするプロセスが開始されます。",
      doYouWantToProceed: "続行しますか?",
      systemMaintainanceModeMsg: "「メンテナンス モードに変更」ボタンを押すとプロセスが開始され、システムは「メンテナンス モード」に入り、リセット時に計算された EDP は次のリセットまで（1 ～ 6 か月かかる可能性があります）各動物で一定に保たれます。",
      errorFetchingContemporaryGrpMsg: "現代のグループ データの取得中にエラーが発生しました",
      deleteSuccess: "削除成功",
      deleteSuccessMsg: "現代のグループは正常に削除されました。",
      deleteFailed: "削除に失敗しました",
      deleteFailedMsg: "現代のグループ データの削除中にエラーが発生しました",
      deleteContemporaryGrpMsg: "この現代グループを削除してもよろしいですか?",
      addBirthWeightData: "出生体重データの追加",
      addWeaningWeightData: "離乳体重データの追加",
      birthWeightContemporaryGroupCode: "出生体重 現代のグループコード",
      dateWeighted: "日付加重",
      addYearlingWeightData: "当歳馬体重データの追加",
      addCarcassWeightData: "枝肉重量データの追加",
      weaningOrYearlingContemporaryGroupCode: "離乳または一歳馬の体重 現代のグループコード",
      deleteContemporaryGroupMsg: "現代グループを削除してもよろしいですか?",
      updateSuccessMsg: "現代グループは正常に更新されました。",
      errorMsg: "何か問題が発生しました。",
      fetchErrorMsg: "選択した特性の必須フィールドを取得中にエラーが発生しました。",
      forMaintainanceMode: "メンテナンスモードの場合",
      ancestorsWeightFactor: "祖先の重み係数",
      weightGivenToTheAncestorFactor: "メンテナンス モードでの EPD 計算の CG 係数に対する祖先係数に与えられる重み。 ",
      addEPDModelSettingsData: "EPDモデル設定データの追加",
      minimumNumberOfAnimalsInContemporaryGroups: "現代のグループの動物の最小数",
      enterNumberOfAnimals: "動物の数を入力してください",
      areYouSureYouWantToChangeEPDCalculation: "必須の EPD 計算フィールドを変更してもよろしいですか?",
      weightOfAnimalAtBirth: "出生時の動物の体重",
      seasonIsAPeriodOfYear: "季節とは、特別な気候条件によって区別される 1 年の期間です。",
      codeOfBirthWeightContemporaryGroup: "出生体重現代グループのコード",
      weaningWeightOfCalf: "子牛の離乳体重",
      dateAnimalWasWeaned: "動物が離乳した日",
      genderOfWeaningAnimal: "離乳動物の性別",
      yearlingWeightOfCalf: "子牛の当歳体重",
      dateAnimalWasWeighted: "動物の体重を測定した日付",
      yearledAnimalSex: "生まれた動物の性別",
      dateOfAnimalKilledForMeat: "食肉のために殺された動物の日付",
      addSuccessMsg: "現代のグループが正常に追加されました",
      traitH: "EPD 計算用のトレイト。",
      searchByValue: "登録番号/タトゥー/名前/タグを入力してください"
    }
  }